module.exports = __webpack_public_path__ + "img/Hair-density1@2x.242af1be.jpg";